import {
  calculateTax as publicCalculateTax,
  listTaxCalculators as publicListTaxCalculators,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const calculateTax: MaybeContext<
  BuildRESTFunction<typeof publicCalculateTax> & typeof publicCalculateTax
> = /*#__PURE__*/ createRESTModule(publicCalculateTax);
export const listTaxCalculators: MaybeContext<
  BuildRESTFunction<typeof publicListTaxCalculators> &
    typeof publicListTaxCalculators
> = /*#__PURE__*/ createRESTModule(publicListTaxCalculators);

export { JurisdictionType } from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
export {
  TaxCalculationGateway,
  CalculateTaxRequest,
  Address,
  LineItem,
  AddressIndex,
  AddressIndexAddressIndexOptionsOneOf,
  MultipleAddresses,
  CalculateTaxResponse,
  TaxSummary,
  AggregatedTaxBreakdown,
  LineItemTaxDetails,
  TaxBreakdown,
  LineItemTaxSummary,
  ApplicationError,
  ListTaxCalculatorsRequest,
  ListTaxCalculatorsResponse,
  TaxCalculatorDetails,
  CalculateTaxResponseNonNullableFields,
  ListTaxCalculatorsResponseNonNullableFields,
  CalculateTaxOptions,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
